import { Container, Grid } from '@material-ui/core'
import FormAddExternalProject from '../component/web/manageExternalProject/search/addExternalProject/FormAddExternalProject'

const AddExternalProject = () => {
    return (
        <Container maxWidth="lg">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormAddExternalProject />
                </Grid>
            </Grid>
        </Container>
    )
}

export default AddExternalProject
